import { CircularProgress, TextField, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useState } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import getOptions from 'services/getOptions';
import Environment from 'utils/environments';
import { ProductsSelectorContainer } from '../../../styles';

const environment = Environment(process.env.REACT_APP_ENV);

const ProductsSelector = ({ product, setProduct = () => {} }) => {
  const { id: paramsID } = useParams();

  const [data, setData] = useState([]);
  const [inputValue, setInputValue] = useState(product?.description ?? '');
  const [debounceTimer, setDebounceTimer] = useState(null);
  const [loading, setLoading] = useState(false);

  const getProducts = (value) => {
    if (debounceTimer) clearTimeout(debounceTimer);

    const newTimer = setTimeout(() => {
      setLoading(true);

      getOptions(
        `${environment.catalog}/stocks`,
        'products',
        data,
        (newData) => setData((prev) => [...new Set([...prev, ...newData])]),
        paramsID,
        value ? { productDescription: value, autoComplete: true } : null,
        null,
        10
      );

      setTimeout(() => setLoading(false), 1100);
    }, 400);

    setDebounceTimer(newTimer);
  };

  return (
    <ProductsSelectorContainer>
      <Autocomplete
        onChange={(_, value) => {
          setProduct(value);
          setInputValue(value?.description || '');
        }}
        inputValue={inputValue}
        onInputChange={(_, newInput, reason) => {
          if (reason === 'input') {
            setInputValue(newInput);
            getProducts(newInput);
          }
        }}
        clearOnEscape
        fullWidth
        style={{ flex: 1, minWidth: 200 }}
        size="small"
        noOptionsText="Nada encontrado. Digite o nome do produto"
        getOptionLabel={(option) => option?.description || ''}
        options={data}
        value={product || null}
        loading={loading}
        renderInput={(params) => (
          <TextField
            {...params}
            id={params?.id}
            name="produtos"
            variant="outlined"
            style={{ borderRadius: '100px', height: '45px' }}
            placeholder="Buscar produto..."
            InputProps={{
              ...params.InputProps,
              style: { borderRadius: '100px', height: '45px' },
              endAdornment: (
                <>
                  {loading ? (
                    <CircularProgress color="inherit" size={16} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              )
            }}
          />
        )}
        renderOption={(option) => (
          <Typography style={{ fontSize: '12px', fontFamily: 'Lato' }}>
            {option?.description}
          </Typography>
        )}
      />
    </ProductsSelectorContainer>
  );
};

export default ProductsSelector;
